import { Injectable } from '@angular/core';
import { OkObject } from '@it2go/types';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { CalendarCheckoutObject, CalendarCheckoutObjectGrid } from '@libs/types/src/services/object-type/calendar/calendar-checkout.object';
import {
    CalendarCheckoutCreateInput,
} from '@libs/types/src/services/input-type/calendar/calendar-checkout.create-input';
import { CalendarCheckoutPatchInput } from '@libs/types/src/services/input-type/calendar/calendar-checkout.patch-input';

@Injectable({ providedIn: 'root' })
export class CalendarCheckoutGqlService extends GqlServiceV2 {

    public getCalendarCheckouts(input: GridInput, fragment: string) {
        return this.query<CalendarCheckoutObjectGrid>(
            `
                query($input: GridInput!) {
                    calendarCheckout {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createCalendarCheckout(input: CalendarCheckoutCreateInput, fragment: string) {
        return this.mutate<CalendarCheckoutObject>(
            `
                mutation($input: CalendarCheckoutCreateInput!) {
                    calendarCheckout {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public patchCalendarCheckout(input: CalendarCheckoutPatchInput, fragment: string) {
        return this.mutate<CalendarCheckoutObject>(
            `
                mutation($input: CalendarCheckoutPatchInput!) {
                    calendarCheckout {
                        patch(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteCalendarCheckout(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    calendarCheckout {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
